<template>
    <div class="row">
        <div class="col-xl-12 col-lg-12">
            <div class="card azure">
                <div class="card-header">
                    <div class="basic-form" style="width:100%">
                        <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label>Idioma:</label>
                                <select class="form-control" v-model="cidadeSobreEditado.idioma">
                                    <template v-if="idiomas && idiomas.length > 0">
                                        <option v-for="idioma in idiomas" v-bind:key="idioma.ididioma"
                                            :value="idioma.codidioma"
                                            :selected="cidadeSobreEditado.idioma==idioma.codidioma">{{idioma.descidioma}}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <div class="form-group col-sm-8">
                                <label>Título:</label>
                                <input v-model="cidadeSobreEditado.titulo" 
                                    type="text" class="form-control" placeholder="Título do ítem sobre a cidade">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-8">
                                <label>Subtítulo:</label>
                                <input v-model="cidadeSobreEditado.subtitulo" 
                                    type="text" class="form-control" placeholder="Subtítulo do ítem sobre a cidade">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label>Texto:</label>
                                <input v-model="cidadeSobreEditado.texto" 
                                    type="text" class="form-control" placeholder="Texto do ítem sobre a cidade">
                            </div>
                        </div>
                        <!-- Imagem -->
                        <div v-if="cidadeSobreEditado.idcidadesobre>0" class="form-group col-sm-auto">
                            <label>Imagem:</label>
                            <div class="imagem-promocao">
                                <label class="ponteiro" :for="'file_'+cidadeSobreEditado.idcidadesobre">
                                    <div v-if="!imagemSrc"><span class="material-icons icon form-control">hotel</span></div>
                                    <img v-if="imagemSrc" :src="'data:' + cidadeSobreEditado.tipoImg + ';base64,' + imagemSrc" 
                                        :id="'imgPromo_'+cidadeSobreEditado.idcidadesobre"
                                    />
                                </label>
                                <input @change="onFileChange" type="file" :id="'file_'+cidadeSobreEditado.idcidadesobre" 
                                    :name="'file_'+cidadeSobreEditado.idcidadesobre" accept="image/png,image/jpg,image/jpeg" 
                                    class="ponteiro" style="display:none;">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label>Rodapé:</label>
                                <input v-model="cidadeSobreEditado.rodape" 
                                    type="text" class="form-control" placeholder="Rodapé do ítem sobre a cidade">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-auto">
                                <a v-on:click="$emit('save',cidadeSobreEditado)" class="ponteiro text-white btn btn-info mt-4">Salvar</a>
                            </div>
                            <div class="form-group col-sm-auto">
                                <a v-on:click="$emit('close')" class="ponteiro text-white btn btn-info mt-4">Fechar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import CONSTANTS from '../constants'
import { serializarImagem } from '../utils/serializar'
export default {
    props: {
        cidadeSobre: {
            type: Object,
            required: true,
        }
    },    
    data() {
        return {
            idiomas: [],
            headers: {
                'x-access-token': this.$store.getters.GetLoginInfo.token
            },
            cidadeSobreEditado: {},
            imagemSrc: null,    
            tipoImg: null
        }
    },
    methods: {
        onFileChange(e) {
            serializarImagem(e, 0.5).then(resp =>{
                this.imagemSrc = resp.dados
                this.tipoImg = resp.tipo
                if (this.cidadeSobreEditado.idcidadesobre > 0) {
                    this.salvarImagem(resp.tipo);
                }
            }).catch(er =>{
                console.error(er)
            })
        },        
        salvarImagem(tipoImg) {
            if (!this.imagemSrc.length > 0) {
                console.error("Imagem inválida!");
                return;
            }
            var params = {
                "tipo" : tipoImg,
                "nome" : "Imagem_Cidade_Sobre_"+this.cidadeSobreEditado.idcidadesobre,
                "dados" : this.imagemSrc,
                "tabela": "cidadesobre",
                "fk": "imagem",
                "chave": "idcidadesobre",
                "valor": this.cidadeSobreEditado.idcidadesobre,
                "idusuario": this.$store.getters.GetLoginInfo.idusuario,
                "deleteold": false
            }
            //console.error(JSON.stringify(params))
            axios.post(CONSTANTS.API_URL + '/fdguest/imagem/upinsert'
                    ,params, { timeout:60000, headers: this.headers })
                .then((response) => {
                    if(response.status == 200){
                        this.cidadeSobreEditado.imagem = response.data.result.imagem[0]
                        console.log('response.data:'+response.data)
                    }else{
                        console.log(JSON.stringify(response))
                    }
                })
                .catch((error) => {
                    console.log(error.response);
            });
        },
		carregarImagem() {
            if (this.cidadeSobreEditado.imagem) {
                this.imagemSrc = null
                this.tipoImg = null
                axios.post(CONSTANTS.API_URL + '/fdguest/imagem/select', 
                    { id: this.cidadeSobreEditado.imagem }, { headers: this.headers })
                .then((response) => {
                    if (response.status == 200) {
                        var imgObj = response.data[0]
                        if (imgObj) {
                            this.imagemSrc = Buffer.from(imgObj.dados).toString()
                            this.tipoImg = imgObj.tipo
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
            }
		},        
        loadIdiomas() {
			axios.post(CONSTANTS.API_URL + '/fdguest/idiomas/suportados', {
				tipo: "U",
				idusuario: this.$store.getters.GetLoginInfo.idusuario
			}, {headers: this.headers})
			.then(response => {
				try {
					if (response.status == 200) {
						if (response.data) {
							this.idiomas = response.data;
						}
					}
				}
				catch(e) {
					console.log(e);
				}
			}).catch((err) => {
				console.log({ err_menu: err });
			});
        }
    },
    computed: {
    },
    beforeMount() {
        this.loadIdiomas();
    },
    mounted() {
        this.cidadeSobreEditado = {... this.cidadeSobre}
        this.carregarImagem()
    }
}
</script>

<style scoped>
.azure {
    background-color: azure!important;
}
</style>